import _ from 'lodash'
import RepeatByHeaderCell from './repeat-by-header-cell'
import reportConstants from 'scoreboard/reports/report-constants'

/**
 * Represents a cell within a middle level multi stack layout
 */
class MiddleRepeatByHeaderCell extends RepeatByHeaderCell {

	constructor(stack, columnAttrsOrBreakdownData, repeatByAttributes, opts = {}) {
		super(stack, columnAttrsOrBreakdownData, repeatByAttributes, opts)
		this.position = reportConstants.REPEAT_BY_MIDDLE_POSITION
	}

	rowIndex() {
		return 1
	}

	/**
	 * Returns the dom nodes that compose the complete side of the header cell
	 * stack.  In this case this would be the header node of this row, the
	 * first/last header cell for each of the repeating headers, and the
	 * first/last body nodes underneath those repeating headers
	 */
	sideDomNodes(left) {
		//find the number of child headers under this header
		let childHeadersPerRepeatedColumn = this.options.childCells.length
		let childIndex = left ? 0 : childHeadersPerRepeatedColumn-1

		let sideNodes = []
		//get the side node for the header itself
		sideNodes.push(...this.domNodes())
		//get the side nodes for the child header that corresponds to either
		//the left or right side of this header
		sideNodes.push(...this.options.childCells[childIndex].sideDomNodes())

		return sideNodes
	}

	isSameLevel(cell) {
		return this.isSameRepeatBy(cell) && cell instanceof MiddleRepeatByHeaderCell
	}

}

export default MiddleRepeatByHeaderCell
MiddleRepeatByHeaderCell.__filename__ = 'reports/common/table/middle-repeat-by-header-cell.js'
